import { Component, OnInit } from '@angular/core'
import * as parser from 'ua-parser-js'
import { linkAndroidStore, linkAppleStore, urlScheme } from '../../../helper/common'
import { ActivatedRoute, ParamMap } from '@angular/router'
import { DomSanitizer } from '@angular/platform-browser'

@Component({
    selector: 'app-active-token',
    templateUrl: './active-token.component.html',
    styleUrls: ['./active-token.component.css'],
})
export class ActiveTokenComponent implements OnInit {
    testUA = new parser()
    osName = 'Windows'
    linkAndroidStore = linkAndroidStore
    linkAppleStore = linkAppleStore
    urlScheme
    acctiveLinkStore
    trustedUrl
    openLinkStore = false

    constructor(private route: ActivatedRoute, private sanitizer: DomSanitizer) {
        this.route.paramMap.subscribe((params: ParamMap) => {
            if (urlScheme.includes("orthocomm://orthocomm.net")) {
                this.openLinkStore = true
            }
            let accountId = params.get('accountId')
            let token = params.get('token')
            this.urlScheme = urlScheme + accountId + '/' + token
            this.trustedUrl = sanitizer.bypassSecurityTrustUrl(this.urlScheme)
        })
    }

    ngOnInit() {
        this.readUA(window.navigator.userAgent)
    }

    readUA(stringUA) {
        this.testUA.setUA(stringUA)
        let Os = this.testUA.getResult().os
        this.osName = Os.name
        if (Os.name == 'Android') {
            this.acctiveLinkStore = this.linkAndroidStore
        } else if (Os.name == 'iOS') {
            this.acctiveLinkStore = this.linkAppleStore
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/client-app/active-token/active-token.component.ts